import { render, staticRenderFns } from "./RelatedPages.vue?vue&type=template&id=c895d84a&"
import script from "./RelatedPages.vue?vue&type=script&lang=js&"
export * from "./RelatedPages.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports